export enum ContainerAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  JUSTIFIED = 'justified',
}

export interface ButtonContainerProps {
  align?: ContainerAlignment
  className?: string
  children?: any
  wrap?: boolean
}